import { createHandler as initGriffin } from 'griffin-paypal/number';
import { createHandler as initGriffinPhone } from 'griffin-paypal/phone';
import _includes from 'lodash/includes';
let griffinPhoneHandler;
let griffin;

try {
  const metadata = __getInitialData().clientMetadata;
  if (metadata) {
    griffinPhoneHandler = initGriffinPhone(metadata);
    griffin = initGriffin(metadata);
  }
} catch (e) {
  console.log(e);
}

export function getGriffin() {
  return griffin;
}

export function getGriffinPhoneHandler() {
  return griffinPhoneHandler;
}

/**
 * Grabs the griffin metadata
 */
function __getInitialData() {
  const initialDataNode = document.getElementById('initialData');
  const initialDataJSON =
    (initialDataNode && initialDataNode.innerHTML) || '{}';
  try {
    const initialData = JSON.parse(initialDataJSON); // parse the JSON strings to JavaScript objects
    return initialData;
  } catch (e) {
    console.warn('ERROR:donate:initialData', e);
    return {};
  }
}

/*
 * _getAmountValue
 * {Array} griffin currency parts
 */
let _getAmountValue = function (params) {
  var amount = params && params.find((item) => item.type === 'value');
  return amount && amount.value;
};

/**
 * getCurrencyParts
 */
export function getCurrencyParts() {
  return __getInitialData().currencyParts;
}

/**
 * getInitialData
 */
export function getInitialData() {
  return __getInitialData();
}

/**
 * Formats getAmountPlaceHolder
 * {string} placeholder
 */
export function getAmountPlaceHolder() {
  const allParts = __getInitialData().currencyParts || [];
  const amount = allParts.find((item) => item.$ === 'amount');
  return (amount && amount._) || '';
}

/**
 * formatAmount
 * {amount} { currency, value }
 */
export function formatAmount(amount) {
  if (!amount.value) {
    return '';
  }
  return griffin?.formatCurrency(
    {
      value: normalizeNumber(amount.value),
      currency: amount.currency,
    },
    griffin.CURRENCY_FORMAT
  );
}

/**
 * Uses Griffin to format a voucher offer detail percentage
 * @param {string} value percentage value
 */
export function formatPercentage(value) {
  return griffin?.formatNumber(value, { style: 'percent' });
}

/**
 * Format currency
 * @constructor
 * @param {string} currency
 * @param {string} value
 */
export function formatCurrency(params) {
  if (!params.value || !params.currency) {
    return '';
  }
  // Only if __getInitialData().clientMetadata exists.
  // Member does not require to load griffin client, getting amount from p2p iframe.
  if (!__getInitialData().clientMetadata) {
    return params.value;
  }
  let response = griffin?.formatCurrency(
    {
      value: params.value,
      currency: params.currency,
    },
    griffin.CURRENCY_FORMAT.parts()
  );

  return _getAmountValue(response);
}

export function formatCurrencyNoDecimals(params) {
  if (!params.value) {
    return '';
  }
  // Only if __getInitialData().clientMetadata exists.
  // Member does not require to load griffin client, getting amount from p2p iframe.
  if (!__getInitialData().clientMetadata) {
    return params.value;
  }

  var options = griffin.NUMBER_FORMAT;
  options.maximumFractionDigits = 0;

  let formattedCurrency = griffin?.formatNumber(params.value, options);

  return formattedCurrency;
}

export function formatCurrencyAsString(params) {
  if (!params.value || !params.currency) {
    return '';
  }
  // Only if __getInitialData().clientMetadata exists.
  // Member does not require to load griffin client, getting amount from p2p iframe.
  if (!__getInitialData().clientMetadata) {
    return params.value;
  }

  let response = griffin?.formatCurrency(
    {
      value: params.value,
      currency: params.currency,
    },
    griffin.CURRENCY_FORMAT
  );
  return response;
}

/**
 * normalizer number
 * {number} {amount}
 * https://github.paypal.com/Globalization-R/griffin-paypal/blob/develop/lib/client/README.md#normalizenumber
 */
export function normalizeNumber(amount) {
  if (!amount) {
    return '';
  }
  return griffin?.normalizeNumber(amount);
}

/**
 * formatInputAmount
 * {string} amount
 */
export function formatInputAmount(amount) {
  if (!amount.value) {
    return '';
  }

  return _getAmountValue(
    griffin?.formatCurrency(
      {
        value: normalizeNumber(amount.value),
        currency: amount.currency,
      },
      griffin.CURRENCY_FORMAT.parts()
    ) || []
  );
}

/**
 * Uses griffin to format phone number
 *
 * @param  {String} countryCode    country phone code. Eg: '1', '41', '91'
 * @param  {String} nationalNumber Phone number Eg: '012312', '418419'
 * @return {String}                Formatted phone number Eg: '(418) 400 1234'
 */
export function formatPhone(countryCode, nationalNumber) {
  if (!griffinPhoneHandler) {
    return nationalNumber;
  }

  const phoneObj = {
    countryCode,
  };

  try {
    const formattedPhone = griffinPhoneHandler.formatAsTyped(
      nationalNumber,
      phoneObj
    );
    return formattedPhone;
  } catch (e) {
    // Happens when phone number contains invalid characters
    return '';
  }
}

export function validatePhone(countryCode, nationalNumber) {
  if (!griffinPhoneHandler) {
    return false;
  }

  try {
    const normalizedPhone =
      griffinPhoneHandler.normalizePhoneNumber(nationalNumber);

    if (!normalizedPhone || normalizedPhone.errors) {
      return false;
    }

    const validationResult =
      griffinPhoneHandler.validatePhoneNumber(normalizedPhone);
    if (validationResult && validationResult.errors) {
      return false;
    }
    return true;
  } catch (e) {
    console.log('e ', e);
    return false;
  }
}

/**
 * Removes country code from phoneNumber
 * Eg:
 * Input: "+49 6645878508"
 * Output: "6645878508"
 */
export function getPhoneNumberWithoutCountryCode(phoneNumber) {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return phoneNumber;
  }

  const firstCharacter = phoneNumber[0];
  if (firstCharacter !== '+') {
    // No country code
    return phoneNumber;
  }

  const firstSpaceIndex = phoneNumber.indexOf(' ');
  // No Space !! Malformed?
  if (firstSpaceIndex === -1) {
    return phoneNumber;
  }

  // First space is last character?
  if (phoneNumber.length < firstSpaceIndex + 1) {
    return phoneNumber;
  }

  return phoneNumber.substr(firstSpaceIndex + 1);
}

export function getDateFormat() {
  var initialData = __getInitialData();
  var dateFormat =
    (initialData.dateMetadata && initialData.dateMetadata.pattern) ||
    'DD/MM/YY';

  return dateFormat.toUpperCase();
}

export function exchangeRateDecimalPoints(amount, decimalPoint, symbol) {
  let exchangeRate = amount;
  let decimal = _includes(exchangeRate, decimalPoint) // checks that exchange rate actually contains the decimal point that it's receiving from the the api call
    ? decimalPoint
    : '.';
  let values = exchangeRate.split(decimal)[1].split(''); // splits the value so that it can get all of the numbers after the decimal place and put them in an array ex. 0.00541 => [0, 0, 5, 4, 1]
  let totalDecimals = 0;
  for (let index = 0; index < values.length; index++) {
    if (values[index] > 0) {
      totalDecimals = index + 2;
      break;
    }
  }
  amount = parseFloat(amount).toFixed(totalDecimals);
  return `${symbol}${amount}`.replace(
    // replaces the decimal just to show it for the expected country
    /[.|,]/i,
    decimalPoint
  );
}

export function formatCurrencyWithSymbol(params) {
  return griffin?.formatCurrency(params, griffin.CURRENCY_FORMAT);
}
